// This file exists because of circular dependency errors
// https://ngrx-entity-relationship.sudo.eu/help/circular-dependency

import { createSelector } from '@ngrx/store';
import { BottomPanelTabs } from '../locations-skeleton.component';
import { selectBottomPanelActive, selectIsMapActive, selectSelectedBottomPanelTab } from './locations-skeleton-selectors';
import { selectIsCvButtonActive } from '../map/state/map-selectors';

export const selectIsCcOn = createSelector(
    selectBottomPanelActive, selectSelectedBottomPanelTab, (bottomPanelActive, bottomPanelTab) => {
      return bottomPanelActive && bottomPanelTab === BottomPanelTabs.CC_RESULTS;
    });

export const selectIsCvOn = createSelector(
    selectIsCvButtonActive, selectIsMapActive, (
        cvButtonActive, mapActive) => {
      return cvButtonActive && mapActive;
    });